import {trigger, state, style, transition, animate,} from "@angular/animations";

export const animateText = trigger('animateText', [
    state('hide',
        style({
            'display': 'none',
            opacity: 0,
        })
    ),
    state('show',
        style({
            'display': 'block',
            opacity: 1,
        })
    ),
    transition('close => open', animate('1000ms ease-in')),
    transition('open => close', animate('200ms ease-out')),
]);